/**
 * Standard duration for all Levumi tests in minutes.
 * Per spec: "Bearbeitungszeit beträgt 5 min"
 */
export const LEVUMI_TEST_DURATION_MINUTES = 5;

/**
 * Standard duration for all Levumi tests in milliseconds.
 * Used by frontend timer components.
 */
export const LEVUMI_TEST_DURATION_MS = LEVUMI_TEST_DURATION_MINUTES * 60 * 1000;
